(function () {
  // Only run for grid-atc quick add clicks, and only if the click is on the quick-add button
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest('.product-item__quick-add-wrapper[data-force-grid-atc="true"] button');
      if (!btn) return;

      // Give Cornerstone's AJAX add-to-cart time to complete + update DOM
      setTimeout(function () {
        // 1) Try common Cornerstone/Fluorescent drawer toggles first
        var trigger =
          document.querySelector('[data-drawer-toggle="cart"]') ||
          document.querySelector('[data-drawer-trigger="cart"]') ||
          document.querySelector('[data-cart-drawer-toggle]') ||
          document.querySelector('[data-cart-toggle]') ||
          document.querySelector('[data-header-cart]') ||
          document.querySelector('[aria-controls="cart-drawer"]') ||
          document.querySelector('[aria-controls*="cart"]') ||
          document.querySelector('.header__icon--cart') ||
          document.querySelector('.header__cart') ||
          document.querySelector('.header__cart-toggle');

        if (trigger) {
          trigger.click();
          return;
        }

        // 2) If Cornerstone uses a custom event, try event-based opens (harmless if unused)
        document.dispatchEvent(new CustomEvent("cart:open"));
        document.dispatchEvent(new CustomEvent("cart:toggle", { detail: { open: true } }));
        document.dispatchEvent(new CustomEvent("theme:cart:open"));
        document.dispatchEvent(new CustomEvent("drawer:open", { detail: { drawer: "cart" } }));

        // 3) Last resort: if there is an actual cart drawer element, try opening it by class/attribute
        var drawer =
          document.querySelector("#cart-drawer") ||
          document.querySelector('[data-drawer="cart"]') ||
          document.querySelector('[data-drawer-id="cart"]');

        if (drawer) {
          drawer.classList.add("is-open", "open", "active");
          drawer.setAttribute("aria-hidden", "false");
        }
      }, 900);
    },
    true
  );
})();